import React from "react";
import { Modal, Table } from "react-bootstrap";
import { TradingInstance } from "../../types";

interface AlgoInstancesModalProps {
  show: boolean;
  onHide: () => void;
  instances: TradingInstance[];
}

const AlgoInstancesModal: React.FC<AlgoInstancesModalProps> = ({
  show,
  onHide,
  instances,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Running Instances</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {instances.length === 0 ? (
          <p className="text-center text-muted">No instances found for this algo.</p>
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Account</th>
                <th>Broker</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {instances.map((instance) => (
                <tr key={instance.id}>
                  <td>{instance.name}</td>
                  <td>
                    {instance.broker_account?.name ||
                      instance.broker_account?.account_id ||
                      "N/A"}
                  </td>
                  <td>
                    <span
                      className={`badge ${
                        instance.status === "live"
                          ? "bg-success"
                          : instance.status === "paused"
                          ? "bg-warning"
                          : instance.status === "interrupted"
                          ? "bg-danger"
                          : "bg-secondary"
                      }`}
                    >
                      {instance.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AlgoInstancesModal;
